import { App } from 'vue';
import FxH5 from './fxH5/index.vue'
import FxApp from './fxApp/index.vue'
import FxPage from './FxPage/index.vue';
import FxArticleItem from './fxArticleItem/index.vue';
import FxArticleList from './fxArticleList/index.vue';

import FxModelLogin from './fxModelLogin/index.vue';
import FxLayout from './fxLayout/index.vue';


const comps =[
  FxApp,
  FxPage,
  FxH5,
  FxArticleItem,
  FxArticleList,
  FxLayout
];

const pageModel = [FxModelLogin]

const install=(app:App):void=>{
  var com = [...comps, ...pageModel] ;// .concat()
  com.forEach(component=>{
    console.log("install", component.name as string)
    app.component(component.name as string, component)
  })
}

let windowObj = window as any

/* 支持使用标签的方式引入 */
if (typeof windowObj !== 'undefined' && windowObj.Vue) {
  const vm = windowObj.Vue.createApp({})
  install(vm)
}
export const getPageModel = pageModel
export default install

export {
  FxApp,
  FxPage,
  FxLayout
}




// export const packageUi = import.meta.glob('./**/**.vue', { eager: true });

// console.log("package", packageUi)
// const components:any = [];
// for (const path in packageUi) {
//   const component = packageUi[path];
//   console.log("package", component)
//   console.log("package", component.default.name)
//   components.push({
//     name: component.default.name,
//     ...component.default,
//   });
// }

// export default {
//     install(app:App) {
//       components.forEach((item: any) => {
//         console.log("item", item)
//         app.component(item.name, item);
//       });
//     },
//   };
  




